import React from 'react';
import css from './AdminActionsNav.css';
import classNames from 'classnames';

const isFunc = f => typeof f === 'function';

export default ({ handleAdding, handleWatchList, handleShowingOutdated, showOutdated }) => (
    <nav>
        {isFunc(handleAdding) && (
            <p className={css.badge} onClick={handleAdding}>
                admin::add
            </p>
        )}
        {isFunc(handleWatchList) && (
            <p className={css.badge} onClick={handleWatchList}>
                admin::watch::list
            </p>
        )}
        {isFunc(handleShowingOutdated) && (
            <p
                className={classNames(css.badge, { [css.selected]: showOutdated })}
                onClick={handleShowingOutdated}
            >
                admin::outdated
            </p>
        )}
    </nav>
);
